import { Section, Eyebrow, H1, FadeIn } from "../components/Primitives";

const sections = [
  {
    title: "Acceptance of terms",
    body: "By accessing or using Register to Digital, you agree to be bound by these Terms & Conditions. If you do not agree, please do not use the service."
  },
  {
    title: "User accounts",
    body: "You are responsible for maintaining the confidentiality of your account and password. You agree to provide accurate information and notify us immediately of any unauthorised use."
  },
  {
    title: "Acceptable use",
    body: "You agree not to misuse Register to Digital. This includes attempting to reverse engineer the service, uploading illegal content, or using the platform to violate the rights of others."
  },
  {
    title: "Subscriptions & billing",
    body: "Paid plans are billed monthly or yearly in advance. You can upgrade, downgrade or cancel at any time from your account settings. Cancellations take effect at the end of the current billing period."
  },
  {
    title: "Refund policy",
    body: "We offer a 7-day money-back guarantee on first-time paid subscriptions. To request a refund, email info@registertodigital.com within 7 days of your first paid invoice. Renewals are non-refundable."
  },
  {
    title: "Intellectual property",
    body: "Register to Digital, including all its software, designs and trademarks, is owned by Register to Digital Pvt. Ltd. Your data, however, remains yours."
  },
  {
    title: "Limitation of liability",
    body: "To the maximum extent permitted by law, Register to Digital is not liable for any indirect, incidental or consequential damages arising from your use of the service."
  },
  {
    title: "Governing law",
    body: "These terms are governed by the laws of India. Any disputes will be resolved in the courts of Meerut, Uttar Pradesh."
  },
  {
    title: "Changes to these terms",
    body: "We may update these terms from time to time. We'll notify you of material changes by email or via an in-app notice."
  },
];

export default function TermsPage() {
  return (
    <div data-testid="page-terms">
      <Section className="pt-24 pb-12">
        <FadeIn><Eyebrow>Legal</Eyebrow></FadeIn>
        <FadeIn delay={0.05}><H1 className="mt-6 max-w-3xl">Terms & Conditions</H1></FadeIn>
        <FadeIn delay={0.1}>
          <p className="mt-5 text-sm text-zinc-500">Last updated: December 2, 2025</p>
        </FadeIn>
      </Section>

      <Section className="pt-0">
        <div className="mx-auto max-w-3xl space-y-10">
          {sections.map((s, i) => (
            <div key={s.title} data-testid={`terms-section-${i}`}>
              <h2 className="font-poppins text-xl font-semibold text-zinc-950">{s.title}</h2>
              <p className="mt-3 text-base leading-relaxed text-zinc-600">{s.body}</p>
            </div>
          ))}
        </div>
      </Section>
    </div>
  );
}
